import { Condition } from 'types/content';

interface IConditionMap {
  [key: string]: Condition;
}

const conditionMap: IConditionMap = {
  compare_to_original_medicare: {
    expectedValue: 'original_medicare',
    operator: 'Equals',
    variableName: 'builderData.group_plan_comparison_type',
  },
  has_white_labeling: {
    expectedValue: '',
    operator: 'IsTrue',
    variableName: 'builderData.has_white_labeling',
  },
};

export default conditionMap;
